import { reactive } from "vue";

const state = reactive({
  pendingRequests: 0,
  loadingMessage: "Loading...",
  alert: {
    visible: false,
    type: "info",
    message: "",
  },
  confirmation: {
    visible: false,
    title: "Please confirm",
    message: "",
    confirmText: "Confirm",
    cancelText: "Cancel",
  },
});

let alertTimer = null;
let confirmationResolver = null;

export function startLoading(message = "Loading...") {
  state.pendingRequests += 1;
  state.loadingMessage = message;
}

export function stopLoading() {
  state.pendingRequests = Math.max(0, state.pendingRequests - 1);
  if (state.pendingRequests === 0) state.loadingMessage = "Loading...";
}

export function showAlert(message, type = "info", duration = 4000) {
  if (alertTimer) clearTimeout(alertTimer);

  state.alert = { visible: true, type, message };
  alertTimer = setTimeout(hideAlert, duration);
}

export function hideAlert() {
  state.alert.visible = false;
}

export function confirmAction(options = {}) {
  state.confirmation = {
    visible: true,
    title: options.title || "Please confirm",
    message: options.message || "Do you want to continue?",
    confirmText: options.confirmText || "Confirm",
    cancelText: options.cancelText || "Cancel",
  };

  return new Promise((resolve) => {
    confirmationResolver = resolve;
  });
}

export function resolveConfirmation(confirmed) {
  state.confirmation.visible = false;

  if (confirmationResolver) {
    confirmationResolver(confirmed);
    confirmationResolver = null;
  }
}

export default state;
